import React, { useEffect, useRef } from 'react';
import { useTranslate } from '@bynder/localization';
import { IconTag } from '@bynder/icons';
import { calculateHeightStyle } from './calculateHeightStyle';
import { SearchItem, SearchResults } from '../../../types';
import { onTagSearch } from '../helpers/searchUtils';
import { iconSizeMedium } from '../../../helpers/iconSizes';

interface Props {
	searchTerm: string;
	results: SearchResults;
	clearSearchTerm: () => void;
	currentActiveSearchItem: SearchItem | undefined;
}

export function GroupTags({
	searchTerm,
	results,
	clearSearchTerm,
	currentActiveSearchItem,
}: Props) {
	const { translate } = useTranslate();
	const { tags } = results;

	const ref = useRef<HTMLLIElement>(null);

	useEffect(() => {
		if (ref.current) {
			ref.current.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
		}
	}, [currentActiveSearchItem]);

	return (
		<>
			<li className="spotlight-alltags">
				<a href="#" className="header no-click" onClick={onDisabledClick}>
					<IconTag size={iconSizeMedium} />
					{translate('tags.allTagsFor')} <b>{searchTerm}</b>
				</a>
			</li>
			<div className="spotlight-results" style={calculateHeightStyle(results)}>
				<ul>
					{tags.map((tagName, index) => {
						if (index % 2 !== 0) {
							return null;
						}

						const tagQty = tags[index + 1];

						return (
							<li
								className="spotlight-tag"
								data-value={tagName}
								onClick={(e) => onTagSearch(tagName, clearSearchTerm, e)}
								key={tagName}
								ref={currentActiveSearchItem?.name === tagName ? ref : null}
							>
								<a
									href="#"
									className="no-click"
									style={{
										backgroundColor:
											currentActiveSearchItem?.name === tagName
												? '#d5d7da'
												: '',
									}}
								>
									<IconTag size={iconSizeMedium} /> {tagName}
									<span className="searchbox-info">{tagQty}</span>
								</a>
							</li>
						);
					})}
				</ul>
			</div>
		</>
	);
}

const onDisabledClick = (e: React.MouseEvent) => {
	e.stopPropagation();
	e.preventDefault();
};
